module.exports = __webpack_public_path__ + "static/media/Merienda-Regular.47a69df0.ttf";